exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs[data-v-3a5a7aa5] {\n  margin-bottom: 20px;\n}\n.tabs[data-v-3a5a7aa5] .el-tabs__header {\n    margin-bottom: 0;\n}\n.tabs[data-v-3a5a7aa5] .el-tabs__content {\n    display: none;\n}\n.partner-table-container[data-v-3a5a7aa5] {\n  margin: 20px 0;\n}\n.pagination-container[data-v-3a5a7aa5] {\n  margin-top: 20px;\n}\n", ""]);

// exports
